import script from "./CopyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyButton.vue?vue&type=script&setup=true&lang=ts"

import "./CopyButton.vue?vue&type=style&index=0&id=bf980d12&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf980d12"]])

export default __exports__